import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../networking/client';
import { RootState } from '../store';

export interface INationality {
  nationality_id: number;
  nationality_name: string;
}

export interface INationalitiesState {
  status: string;
  nationalities: INationality[];
}

const initialState: INationalitiesState = {
  status: 'idle',
  nationalities: [],
};

export const fetchNationalities = createAsyncThunk(
  'nationalities/fetchAll',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const nationalitiesResponse: any = await client.get('/healthpoint/nationalities');
      return nationalitiesResponse;
    } catch (err: any) {
      return rejectWithValue({});
    }
  }
);

export const nationalitiesSlice = createSlice({
  name: 'nationalities',
  initialState,
  reducers: {
    resetNationalities: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNationalities.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(fetchNationalities.fulfilled, (state, action) => {
        state.nationalities = action.payload.data.nationalities;
        state.status = 'fulfilled';
      })
      .addCase(fetchNationalities.rejected, (state) => {
        state.status = 'rejected';
      });
  },
});

export const { resetNationalities } = nationalitiesSlice.actions;

export default nationalitiesSlice.reducer;

export const selectNationalities = (state: RootState) => state.nationalities.nationalities;
